import { useEffect, useState } from "react";
import Storage from "classes/Storage/Storage";

function useToken() {
	const storage = new Storage(null, null, localStorage);
	const sess_storage = new Storage(null, null, sessionStorage);

	const getToken = () => {
		if (sess_storage.getItem("token")) {
			const userToken = sess_storage.getItem("token");
			return userToken?.access_token;
		}
		const userToken = storage.getItem("token");
		return userToken?.access_token;
	};

	const [token, setToken] = useState(getToken());

	const saveToken = (userToken) => {
		storage.setItem("token", userToken);
		// NE PAS mettre une valeur truthy ici (ex: userToken.access_token) :
		// l'état `token` doit rester falsy pendant le login pour que LoginPage
		// reste montée (flux CGU + account.fetch) jusqu'au reload final. Une
		// valeur truthy fait basculer App.js sur l'app principale trop tôt.
		setToken(userToken.token);
	};

	return {
		setToken: saveToken,
		token,
	};
}

export default useToken;
